var SitePage = require('../views/masters/SitePage');
var $ = require('jquery');
var UIView = require('../modules/ui/uiview');
var UIModal = require('../modules/ui/uimodal');

/**
 * HomePage
 * @constructor
 * @description represent Home Page
 * @extends SitePage
 * @param {Object} options - object contain any attributes
 */

function HomePage(options){
    SitePage.call(this);
    this.options = options;
}

HomePage.prototype = $.extend(Object.create(SitePage.prototype), {

  constructor: HomePage,

  /**
   * Executes when document DOM Tree is ready.
   */
  ready: function() {
    console.log("Ready: HomePage");

    SitePage.prototype.ready.call(this);

    var $btnIngresarHeader = $('.ingresar-button-header'),
        $minBoxIngresar = $('.min-box-ingresar');

    // $('#btn-reg-beneficios').on('click', function(evt) {
    $('.btn-reg-beneficiario').on('click', function(evt) {
      evt.preventDefault();
      evt.stopPropagation();
      var statusLogin = $(this).data('login');
      if (statusLogin) window.location.href = $(this).attr('href');
      else SitePage.prototype._showPopup($minBoxIngresar, $btnIngresarHeader);
    });

    $('#form-activar-invitacion').on('submit', function(evt) {
      if (!$(this).data('login')) {
        evt.preventDefault();
        console.log('entra');
        SitePage.prototype._showPopup($minBoxIngresar, $btnIngresarHeader);
      }
    });

    $('#alert').on('click', function(evt){
      evt.preventDefault();
      if(!window.location.search){
        var viewTemplate = $('#rptamsg').remove().get(0).innerHTML
        var view = new UIView({
          // className: 'modal-msg modal-home-popup',
          template: viewTemplate
        });

        var modal = new UIModal({
          id: 'modal-home',
          overlayCloser: true
        });

        modal.setView(view.render());
        modal.open();

        $('#close-modal').on('click', function() {
          modal.close();
        });
      }
    });

  },

  /*
   * Executes when the window is fully loaded.
   */
  load: function(){
    console.log("Load: HomePage");
  }

});

// Create a instace of this page;
new HomePage({ data: {} });
